import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Typography from '../../atoms/typography';

const ImportDuties = styled(Typography)``;
const FinalSale = styled(Typography)``;
const LeadTime = styled(Typography)``;

const Restrictions = styled.div`
  color: ${(props) => props.theme.color.brandLight};
  line-height: 1.2;
  margin-bottom: 3rem;
  text-align: center;

  > span {
    padding-right: 1rem;
    display: inline-block;

    &:last-of-type {
      padding-right: 0;
    }
  }
`;

const calculateLeadTime = (n) => {
  if (n === 1) {
    return '1 day';
  }

  if (n === 7) {
    return '1 week';
  }

  return n % 7 === 0 ? `${n / 7} weeks` : `${n} days`;
};

const ProductRestrictions = (props) => (
  <Restrictions className={props.className}>
    {props.importDuties && <ImportDuties element="span" like="dec-1">Import duties included</ImportDuties>}
    {(props.finalSale || props.isGiftCard) && <FinalSale element="span" like="dec-1">Final sale</FinalSale>}
    {
      !props.isGiftCard && props.leadTime && (
        <LeadTime element="span" like="dec-1">{`Usually ships within  ${calculateLeadTime(props.leadTime)}`}</LeadTime>
      )
    }
  </Restrictions>
);

ProductRestrictions.defaultProps = {
  className: '',
  importDuties: false,
  finalSale: false,
  leadTime: 0,
  isGiftCard: false
};

ProductRestrictions.propTypes = {
  className: PropTypes.string,
  importDuties: PropTypes.bool,
  finalSale: PropTypes.bool,
  leadTime: PropTypes.number,
  isGiftCard: PropTypes.bool
};

export default ProductRestrictions;
